import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_auth/user/forgot-password')({
  component: UserForgotPasswordRoute,
});

function UserForgotPasswordRoute() {
  const { t } = useTranslation();
  return (
    <PageTransition className="flex flex-col gap-6">
      <ForgotPasswordForm />
      <p className="text-center text-xs text-foreground-subtle">
        <Link to="/user/login" className="font-medium text-foreground-muted underline">
          {t('auth.user.login.backToLogin')}
        </Link>
      </p>
    </PageTransition>
  );
}
